export { PluginsHeader } from './PluginsHeader.component';
